<template>
  <div>
    <div class="sales-report" style="padding-top: 12px !important;">

      <!-- Copy of product view header -->
      <div class="settings-top-bar sticky-header">
        <div class="top-bar">
          <p>
            <a class="btn btn-orange btn-icon back banner-back-button" :title="$t('general.back')" href="#" @click.prevent="goBack">
              <i class="ti-arrow-left"></i>
              {{ $t('general.back') }}
            </a>
          </p>
          <p style="margin-left: auto;">
            <a
              class="btn btn-info btn-icon back"
              :title="$t('general.reload')"
              href="#"
              @click.prevent="refreshNow"
            >
              <i class="ti-reload"></i>
              {{ $t('general.reload') }}
            </a>
          </p>
        </div>
      </div>

      <div class="col-md-12 pos-order-actions-details-table-wrap">
        <div class="card">
          <div class="card-content total-pagination reports-center-columns" style="width: 100%;">
            <data-tables-server
              @query-change="paginationChanged"
              v-loading="loading"
              :data="actions"
              :total="total"
              :pagination-props="paginationProps"
            >
              <el-table-column class-name="centered-cell" prop="id" label="ID" min-width="80" />
              <el-table-column class-name="pos-order-actions-action-col" prop="action_type" :label="$t('general.action')" min-width="260">
                <template slot-scope="props">
                  <span class="pos-order-actions-action-text">
                    {{ actionTypeDisplay(props.row) }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column class-name="centered-cell" prop="amount" label="Total Comanda" min-width="120">
                <template slot-scope="props">
                  {{ props.row.amount != null ? props.row.amount : '-' }}
                </template>
              </el-table-column>
              <el-table-column class-name="centered-cell" prop="product_count" :label="$t('reports.orderProductsCount')" min-width="160">
                <template slot-scope="props">
                  {{ props.row.product_count != null ? props.row.product_count : '-' }}
                </template>
              </el-table-column>
              <el-table-column class-name="centered-cell" prop="transfer_table_id" :label="$t('reports.transferTable')" min-width="160">
                <template slot-scope="props">
                  {{ transferTableName(props.row.transfer_table_id) }}
                </template>
              </el-table-column>
              <el-table-column class-name="centered-cell" prop="payment_method" :label="$t('reports.paymentMethod')" min-width="140">
                <template slot-scope="props">
                  {{ paymentMethodLabel(props.row.payment_method) }}
                </template>
              </el-table-column>
              <el-table-column class-name="centered-cell" prop="pos_id" :label="$t('reports.posId')" min-width="90">
                <template slot-scope="props">
                  {{ posDeviceName(props.row.pos_id) }}
                </template>
              </el-table-column>
              <el-table-column class-name="centered-cell" prop="created_by" :label="$t('reports.operator')" min-width="110">
                <template slot-scope="props">
                  {{ operatorDisplayName(props.row.created_by) }}
                </template>
              </el-table-column>
              <el-table-column class-name="centered-cell" prop="created_at" :label="$t('orders.date')" min-width="170">
                <template slot-scope="props">
                  {{ props.row.created_at ? formatToCompanyTimezone(props.row.created_at) : (props.row.timestamp ? formatToCompanyTimezone(props.row.timestamp) : '-') }}
                </template>
              </el-table-column>
              <el-table-column class-name="centered-cell" :label="$t('general.actions')" min-width="90">
                <template slot-scope="props">
                  <a
                    v-if="props.row && (props.row.transfer_app_id || props.row.transfer_order_app_id)"
                    href="#"
                    class="btn btn-primary btn-icon pos-order-actions-details-action-btn"
                    title="Open transfer order"
                    @click.prevent.stop="openTransferOrder(props.row)"
                    style="margin-right: 6px;"
                  >
                    <i class="ti-share"></i>
                  </a>
                  <a
                    v-if="hasBeforeAfter(props.row)"
                    href="#"
                    class="btn btn-info btn-icon pos-order-actions-details-action-btn"
                    title="Diff"
                    @click.prevent.stop="openBeforeAfterModal(props.row)"
                  >
                    <i class="ti-eye"></i>
                  </a>
                </template>
              </el-table-column>
            </data-tables-server>
          </div>
        </div>
      </div>
    </div>

    <vmodal
      name="posOrderActionsBeforeAfterModal"
      height="auto"
      width="1200"
      :adaptive="true"
      :scrollable="true"
      class="filtersAndSortModal sales-report-filters"
    >
      <div class="card">
        <div class="card-content">
          <div class="modal-header slim-header">
            <h4>{{ $t('general.details') }}</h4>
          </div>
          <div class="modal-body slim-body">
            <div class="filters-grid sales-report-filters-grid pos-order-actions-diff-grid">
              <template v-if="diffModalRow && Number(diffModalRow.action_type) === 6">
                <div class="modal-column-left">
                  <div class="filter-section">
                    <h6>{{ $t('reports.initialItems') }}</h6>
                    <div v-if="transferOutProducts.length" class="pos-order-actions-products">
                      <div
                        v-for="(prod, idx) in transferOutProducts"
                        :key="'xfer-out-' + idx"
                        class="pos-order-actions-product-row"
                        :class="Number(prod.is_storno) === 1 ? 'pos-order-actions-product-row--storno' : (isTransferredOutItem(prod) ? 'pos-order-actions-product-row--transfer' : '')"
                      >
                        <div class="pos-order-actions-product-header">
                          <div class="pos-order-actions-product-name">{{ prod.name }}</div>
                          <div v-if="Number(prod.is_storno) === 1" class="pos-order-actions-product-storno-tag">STORNO</div>
                          <div
                            v-else-if="isTransferredOutItem(prod)"
                            class="pos-order-actions-product-transfer-tag"
                          >{{ $t('reports.transferredTag') }}</div>
                        </div>
                        <div v-if="prod.options && prod.options.length" class="pos-order-actions-product-options">
                          <div v-for="(opt, oidx) in prod.options" :key="'xfer-out-opt-' + idx + '-' + oidx">
                            + {{ opt.name }}<span v-if="Number(opt.price) > 0"> ({{ opt.price }})</span>
                          </div>
                        </div>
                        <div v-if="prod.additional_info" class="pos-order-actions-product-info">
                          {{ $t('orders.custComments') }}: <i class="text-danger">{{ prod.additional_info }}</i>
                        </div>
                        <div class="pos-order-actions-product-meta">
                          <span>{{ $t('orders.qty') }}: <b>{{ prod.quantity }}</b></span>
                          <span v-if="prod.price != null"> | {{ $t('orders.unit') }}: <b>{{ prod.price }}</b></span>
                          <span> | {{ $t('orders.date') }}: <b>{{ productCreatedAtDisplay(prod) }}</b></span>
                        </div>
                      </div>
                    </div>
                    <div v-else class="pos-order-actions-empty">-</div>
                  </div>
                </div>

                <div class="modal-column-right">
                  <div class="filter-section">
                    <div class="pos-order-actions-section-header">
                      <h6>{{ $t('reports.remainingItems') }}</h6>
                      <div class="pos-order-actions-status-wrap" v-if="transferRemainingStatus">
                        <span class="pos-order-actions-status-pill" :class="statusPillClass(transferRemainingStatus)">
                          {{ $t('ordersStatus.' + transferRemainingStatus) }}
                        </span>
                      </div>
                    </div>
                    <div v-if="transferRemainingDisplayProducts.length" class="pos-order-actions-products" style="margin-top: 10px;">
                      <div v-for="(prod, idx) in transferRemainingDisplayProducts" :key="'xfer-rem-' + idx" class="pos-order-actions-product-row">
                        <div class="pos-order-actions-product-name">{{ prod.name }}</div>
                        <div v-if="prod.options && prod.options.length" class="pos-order-actions-product-options">
                          <div v-for="(opt, oidx) in prod.options" :key="'xfer-rem-opt-' + idx + '-' + oidx">
                            + {{ opt.name }}<span v-if="Number(opt.price) > 0"> ({{ opt.price }})</span>
                          </div>
                        </div>
                        <div v-if="prod.additional_info" class="pos-order-actions-product-info">
                          {{ $t('orders.custComments') }}: <i class="text-danger">{{ prod.additional_info }}</i>
                        </div>
                        <div class="pos-order-actions-product-meta">
                          <span>{{ $t('orders.qty') }}: <b>{{ prod.quantity }}</b></span>
                          <span v-if="prod.price != null"> | {{ $t('orders.unit') }}: <b>{{ prod.price }}</b></span>
                          <span> | {{ $t('orders.date') }}: <b>{{ productCreatedAtDisplay(prod) }}</b></span>
                        </div>
                      </div>
                    </div>
                    <div v-else class="pos-order-actions-empty">-</div>
                  </div>
                </div>
              </template>

              <template v-else-if="diffModalRow && Number(diffModalRow.action_type) === 7">
                <div class="filter-section wide-filter">
                  <h6>{{ $t('reports.itemsReceived') }}</h6>
                  <div v-if="transferInProducts.length" class="pos-order-actions-products">
                    <div v-for="(prod, idx) in transferInProducts" :key="'xfer-in-' + idx" class="pos-order-actions-product-row">
                      <div class="pos-order-actions-product-name">{{ prod.name }}</div>
                      <div class="pos-order-actions-product-meta">
                        <span>{{ $t('orders.qty') }}: <b>{{ prod.quantity }}</b></span>
                        <span> | {{ $t('orders.date') }}: <b>{{ productCreatedAtDisplay(prod) }}</b></span>
                      </div>
                    </div>
                  </div>
                  <div v-else class="pos-order-actions-empty">-</div>
                </div>
              </template>

              <template v-else>
                <div class="filter-section wide-filter">
                  <template v-if="diffModalRow && (Number(diffModalRow.action_type) === 2 || Number(diffModalRow.action_type) === 3)">
                    <div v-if="beforeProducts.length" class="pos-order-actions-products">
                      <div v-for="(prod, idx) in beforeProducts" :key="'before-prod-' + idx" class="pos-order-actions-product-row">
                        <div class="pos-order-actions-product-name">
                          {{ prod.name }}
                        </div>
                        <div v-if="prod.options && prod.options.length" class="pos-order-actions-product-options">
                          <div v-for="(opt, oidx) in prod.options" :key="'before-opt-' + idx + '-' + oidx">
                            + {{ opt.name }}<span v-if="Number(opt.price) > 0"> ({{ opt.price }})</span>
                          </div>
                        </div>
                        <div v-if="prod.additional_info" class="pos-order-actions-product-info">
                          {{ $t('orders.custComments') }}: <i class="text-danger">{{ prod.additional_info }}</i>
                        </div>
                        <div class="pos-order-actions-product-meta">
                          <span>{{ $t('orders.qty') }}: <b>{{ prod.quantity }}</b></span>
                          <span v-if="prod.price != null"> | {{ $t('orders.unit') }}: <b>{{ prod.price }}</b></span>
                          <span> | {{ $t('orders.date') }}: <b>{{ productCreatedAtDisplay(prod) }}</b></span>
                        </div>
                      </div>
                    </div>
                    <div v-else class="pos-order-actions-empty">-</div>
                  </template>

                  <template v-else-if="diffModalRow && Number(diffModalRow.action_type) === 4">
                    <div class="pos-order-actions-status-wrap" v-if="orderStatusAfter">
                      <span class="pos-order-actions-status-label">{{ $t('orders.status') }}:</span>
                    <span class="pos-order-actions-status-pill" :class="statusPillClass(orderStatusAfter)">
                        {{ $t('ordersStatus.' + orderStatusAfter) }}
                      </span>
                    </div>
                    <div v-else class="pos-order-actions-empty">-</div>
                  </template>

                  <template v-else-if="diffModalRow && Number(diffModalRow.action_type) === 5">
                    <div class="filter-section wide-filter">
                      <h6>{{ $t('reports.items') }}</h6>
                      <div v-if="stornoAfterProducts.length" class="pos-order-actions-products">
                        <div
                          v-for="(prod, idx) in stornoAfterProducts"
                          :key="'storno-after-' + idx"
                          class="pos-order-actions-product-row"
                          :class="Number(prod.is_storno) === 1 ? 'pos-order-actions-product-row--storno' : ''"
                        >
                          <div class="pos-order-actions-product-header">
                            <div class="pos-order-actions-product-name">{{ prod.name }}</div>
                            <div v-if="Number(prod.is_storno) === 1" class="pos-order-actions-product-storno-tag">STORNO</div>
                          </div>
                          <div v-if="prod.options && prod.options.length" class="pos-order-actions-product-options">
                            <div v-for="(opt, oidx) in prod.options" :key="'storno-after-opt-' + idx + '-' + oidx">
                              + {{ opt.name }}<span v-if="Number(opt.price) > 0"> ({{ opt.price }})</span>
                            </div>
                          </div>
                          <div v-if="prod.additional_info" class="pos-order-actions-product-info">
                            {{ $t('orders.custComments') }}: <i class="text-danger">{{ prod.additional_info }}</i>
                          </div>
                          <div class="pos-order-actions-product-meta">
                            <span>{{ $t('orders.qty') }}: <b>{{ prod.quantity }}</b></span>
                            <span v-if="prod.price != null"> | {{ $t('orders.unit') }}: <b>{{ prod.price }}</b></span>
                            <span> | {{ $t('orders.date') }}: <b>{{ productCreatedAtDisplay(prod) }}</b></span>
                          </div>
                        </div>
                      </div>
                      <div v-else class="pos-order-actions-empty">-</div>
                    </div>
                  </template>

                  <template v-else>
                    <div class="pos-order-actions-empty">-</div>
                  </template>

                  <div v-if="diffModalRow && Number(diffModalRow.action_type) === 3" style="margin-top: 12px;">
                    <div class="pos-order-actions-status-wrap" v-if="printerStatusObj">
                      <span class="pos-order-actions-status-label">Printer status:</span>
                      <span
                        class="pos-order-actions-status-pill"
                        :class="printerStatusObj.status === true ? 'ok' : 'bad'"
                      >
                        {{ printerStatusObj.status === true ? 'OK' : 'FAILED' }}
                      </span>
                    </div>
                  </div>
                </div>
              </template>
            </div>

            <div class="modal-footer slim-footer">
              <el-button size="small" @click="closeBeforeAfterModal">{{ $t('general.close') }}</el-button>
            </div>
          </div>
        </div>
      </div>
    </vmodal>
  </div>
</template>

<script>
import swal from 'sweetalert2'

export default {
  props: {
    // When opened via the global slide-in modal (route meta.modal),
    // the router navigation is cancelled and `route` is passed as a prop from App.vue.
    route: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    // When opening another order in the same slide-in modal, App.vue updates `route` prop
    // but this component instance stays mounted. Refetch on route/app change.
    appId (newVal, oldVal) {
      if (String(newVal || '') === String(oldVal || '')) return
      this.paginationProps.currentPage = 1
      const pageSize = this.paginationProps.pageSize || 20
      this.fetchActions({ page: 1, pageSize })
    }
  },
  created () {
    this.timezone = this.$session.get('selectedCompanyData').timezone || 'Europe/Bucharest'
    this.getPosUsers()
    this.getPosDevices()
    this.fetchActions()
  },
  data () {
    return {
      timezone: null,
      loading: true,
      actions: [],
      total: 0,
      diffModalRow: null,
      posUsers: [],
      posNameById: {},
      transferTableNameById: {},
      paginationProps: {
        layout: 'prev, pager, next, sizes, total',
        currentPage: 1,
        pageSize: 20
      }
    }
  },
  computed: {
    beforeProducts () {
      if (!this.diffModalRow) return []
      const type = Number(this.diffModalRow.action_type)
      if (type !== 2 && type !== 3) return []
      return this.extractProductsFromBefore(this.diffModalRow)
    },
    printerStatusObj () {
      if (!this.diffModalRow || Number(this.diffModalRow.action_type) !== 3) return null
      const obj = this.parseJsonMaybe(this.diffModalRow.data_after)
      return (obj && typeof obj === 'object') ? obj : null
    },
    orderStatusAfter () {
      if (!this.diffModalRow || Number(this.diffModalRow.action_type) !== 4) return null
      const obj = this.parseJsonMaybe(this.diffModalRow.data_after)
      const st = obj && obj.status ? String(obj.status) : null
      return st && st.trim() ? st.trim() : null
    },
    transferOutProducts () {
      if (!this.diffModalRow || Number(this.diffModalRow.action_type) !== 6) return []
      return this.extractTransferOutProducts(this.diffModalRow)
        .filter((it) => !this.isHiddenStornoDisplayLine(it))
    },
    transferRemainingProducts () {
      if (!this.diffModalRow || Number(this.diffModalRow.action_type) !== 6) return []
      return this.extractTransferRemainingProducts(this.diffModalRow)
    },
    transferRemainingDisplayProducts () {
      // Action type 6 sometimes returns "remaining_items" rows that have no name
      // and no comment/options (but still exist in the array). Avoid rendering
      // those as empty product cards.
      const products = this.transferRemainingProducts || []
      return products.filter((p) => {
        if (!p) return false

        const name = p.name != null ? String(p.name).trim() : ''
        const hasName = !!name && name !== '-'

        const hasOptions = Array.isArray(p.options) && p.options.length > 0
        const hasAdditional = p.additional_info != null && String(p.additional_info).trim() !== ''

        const qty = p.quantity != null && p.quantity !== '-' ? Number(p.quantity) : null
        const hasNonZeroQty = qty != null && !isNaN(qty) && qty !== 0

        return hasName || hasOptions || hasAdditional || hasNonZeroQty
      })
    },
    transferRemainingKeySet () {
      // Keys for all lines in data_after.remaining_items (by app_id/name), not only
      // display rows — avoids false "transferred" when a row has app_id but no name.
      const set = new Set()
      if (!this.diffModalRow || Number(this.diffModalRow.action_type) !== 6) return set
      const after = this.parseJsonMaybe(this.diffModalRow.data_after)
      const items = after && Array.isArray(after.remaining_items) ? after.remaining_items : []
      items.forEach((it) => {
        if (!it) return
        const key = this.productCompareKey({
          app_id: it.app_id != null ? it.app_id : null,
          name: it.name != null ? String(it.name) : null
        })
        if (key) set.add(key)
      })
      return set
    },
    transferRemainingStatus () {
      if (!this.diffModalRow || Number(this.diffModalRow.action_type) !== 6) return null
      const after = this.parseJsonMaybe(this.diffModalRow.data_after)
      const st = after && after.status ? String(after.status) : null
      return st && st.trim() ? st.trim() : null
    },
    transferInProducts () {
      if (!this.diffModalRow || Number(this.diffModalRow.action_type) !== 7) return []
      return this.extractTransferInProducts(this.diffModalRow)
    },
    stornoAfterProducts () {
      if (!this.diffModalRow || Number(this.diffModalRow.action_type) !== 5) return []
      return this.extractStornoAfterProducts(this.diffModalRow)
    },
    orderId () {
      return (this.route && this.route.params && this.route.params.orderId != null)
        ? this.route.params.orderId
        : this.$route.params.orderId
    },
    appId () {
      // Prefer app_id from the modal route query; if missing, fall back to the param
      // (some navigations only change the param, and we still need to refetch).
      if (this.route && this.route.query && this.route.query.app_id != null) return this.route.query.app_id
      if (this.route && this.route.params && this.route.params.orderId != null) return this.route.params.orderId
      return (this.$route.query && this.$route.query.app_id)
    }
  },
  methods: {
    productCreatedAtDisplay (prod) {
      if (!prod) return '-'
      const createdAt = prod.created_at || prod.createdAt
      const ts = prod.timestamp || prod.time || prod.created
      const val = createdAt || ts
      return val ? this.formatToCompanyTimezone(val) : '-'
    },
    productCompareKey (p) {
      if (!p) return null
      // Prefer app_id when present (stable), fallback to name.
      const appId = p.app_id != null ? String(p.app_id) : ''
      if (appId) return 'app_id:' + appId
      const name = p.name != null ? String(p.name).trim().toLowerCase() : ''
      if (name && name !== '-') return 'name:' + name
      return null
    },
    isHiddenStornoDisplayLine (it) {
      if (!it || Number(it.is_storno) !== 1) return false
      const priceNum = it.price != null ? Number(it.price) : null
      const priceNegative = priceNum != null && !isNaN(priceNum) && priceNum < 0
      const qtyNum = it.quantity != null && it.quantity !== '-' ? Number(it.quantity) : null
      const qtyNegative = qtyNum != null && !isNaN(qtyNum) && qtyNum < 0
      return priceNegative || qtyNegative
    },
    isTransferredOutItem (prod) {
      // Storno lines leave data_after (or are not in remaining_items); do not label as transferred.
      if (prod && Number(prod.is_storno) === 1) return false
      // "Transferred" = present in initial items, missing from remaining items.
      const key = this.productCompareKey(prod)
      if (!key) return false
      return !this.transferRemainingKeySet.has(key)
    },
    getPosUsers () {
      const data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }
      this.apiRequest('/pos/all/users', 'GET', data, (response) => {
        if (response && response.status === true) {
          this.posUsers = (response.data && response.data.pos_user) ? response.data.pos_user : []
        } else {
          this.posUsers = []
        }
      })
    },
    getPosDevices () {
      const data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }
      this.apiRequest('/pos', 'GET', data, (response) => {
        const map = {}
        if (response && response.status === true && response.data && Array.isArray(response.data.pos)) {
          response.data.pos.forEach(p => {
            if (p && p.id != null) map[p.id] = p.name || ('ID ' + p.id)
          })
        }
        this.posNameById = map
      })
    },
    posDeviceName (posId) {
      if (posId === undefined || posId === null || posId === '') return '-'
      return this.posNameById[posId] || String(posId)
    },
    operatorDisplayName (operatorId) {
      if (operatorId === undefined || operatorId === null || operatorId === '') return '-'
      const u = this.posUsers.find(x => x && (x.id === operatorId || String(x.id) === String(operatorId)))
      if (!u) return String(operatorId)
      const full = `${u.firstname || ''} ${u.lastname || ''}`.trim()
      return full || String(operatorId)
    },
    paymentMethodLabel (method) {
      if (method === undefined || method === null || method === '') return '-'
      const key = String(method)
      const translated = this.$t('paymentTypes.' + key)
      // vue-i18n returns the key itself when missing; detect that and fallback
      if (translated && translated !== ('paymentTypes.' + key)) return translated
      return key
    },
    actionTypeDisplay (row) {
      if (!row) return '-'
      const type = Number(row.action_type)
      if (type === 2) {
        const name = this.extractMarkedProductName(row)
        if (name) return this.$t('reports.posOrderActionMarkProduct', { name })
        return this.$t('reports.posOrderActionMarkProductGeneric')
      }
      return this.actionTypeLabel(row.action_type)
    },
    extractMarkedProductName (row) {
      const productId = row && row.product_id != null ? String(row.product_id) : null

      const findNameByProductId = (payload) => {
        if (!productId) return null

        // Shape A: [{ order_part_items: [...] }]
        if (Array.isArray(payload)) {
          for (const part of payload) {
            const items = part && Array.isArray(part.order_part_items) ? part.order_part_items : []
            for (const it of items) {
              if (!it) continue
              if (it.product_id != null && String(it.product_id) === productId) {
                const n = it.name ? String(it.name) : null
                return n && n.trim() ? n.trim() : null
              }
            }
          }
        }

        // Shape B: { products: [...] }
        if (payload && typeof payload === 'object' && Array.isArray(payload.products)) {
          for (const it of payload.products) {
            if (!it) continue
            if (it.product_id != null && String(it.product_id) === productId) {
              const n = it.name ? String(it.name) : null
              return n && n.trim() ? n.trim() : null
            }
          }
        }

        return null
      }

      const before = this.parseJsonMaybe(row.data_before)

      // Only look in data_before (requested).
      return findNameByProductId(before) || null
    },
    extractProductsFromBefore (row) {
      const payload = this.parseJsonMaybe(row && row.data_before)
      const products = []

      // Shape A (type 2 sample): [{ order_part_items: [...] }]
      if (Array.isArray(payload)) {
        payload.forEach((part) => {
          const items = part && Array.isArray(part.order_part_items) ? part.order_part_items : []
          items.forEach((it) => {
            if (!it) return
            products.push({
              name: it.name ? String(it.name) : '-',
              quantity: it.quantity != null ? it.quantity : '-',
              price: it.price != null ? it.price : null,
              created_at: it.created_at || it.timestamp || null,
              options: Array.isArray(it.options) ? it.options : [],
              additional_info: it.comment ? String(it.comment) : ''
            })
          })
        })
        return products
      }

      // Shape B (type 3 sample): { products: [...] }
      if (payload && typeof payload === 'object' && Array.isArray(payload.products)) {
        payload.products.forEach((it) => {
          if (!it) return
          products.push({
            name: it.name ? String(it.name) : '-',
            quantity: it.quantity != null ? it.quantity : '-',
            price: it.price != null ? it.price : null,
            created_at: it.created_at || it.timestamp || null,
            options: Array.isArray(it.options) ? it.options : [],
            additional_info: it.comment ? String(it.comment) : ''
          })
        })
      }

      return products
    },
    extractTransferOutProducts (row) {
      const before = this.parseJsonMaybe(row && row.data_before)
      const items = before && Array.isArray(before.order_part_items) ? before.order_part_items : []
      return items.map(it => ({
        app_id: (it && it.app_id != null) ? it.app_id : null,
        name: it && it.name ? String(it.name) : '-',
        quantity: it && it.quantity != null ? it.quantity : '-',
        price: it && it.price != null ? it.price : null,
        created_at: it && (it.created_at || it.timestamp) ? (it.created_at || it.timestamp) : null,
        options: it && Array.isArray(it.options) ? it.options : [],
        additional_info: it && it.comment ? String(it.comment) : '',
        is_storno: it && it.is_storno != null ? Number(it.is_storno) : 0
      }))
    },
    extractTransferRemainingProducts (row) {
      const after = this.parseJsonMaybe(row && row.data_after)
      const items = after && Array.isArray(after.remaining_items) ? after.remaining_items : []
      // Remaining items sometimes contain only app_id/quantity/is_deleted (no name).
      // Per UX: if there is no name, do not render an empty product card.
      return items
        .filter(it => it && it.name != null && String(it.name).trim() !== '')
        .map(it => ({
          app_id: (it && it.app_id != null) ? it.app_id : null,
          name: String(it.name),
          quantity: it && it.quantity != null ? it.quantity : '-',
          price: it && it.price != null ? it.price : null,
          created_at: it && (it.created_at || it.timestamp) ? (it.created_at || it.timestamp) : null,
          options: it && Array.isArray(it.options) ? it.options : [],
          additional_info: it && it.comment ? String(it.comment) : ''
        }))
    },
    extractTransferInProducts (row) {
      const after = this.parseJsonMaybe(row && row.data_after)
      const items = after && Array.isArray(after.items_received) ? after.items_received : []
      return items.map(it => ({
        name: it && it.name ? String(it.name) : '-',
        quantity: it && it.quantity != null ? it.quantity : '-',
        created_at: it && (it.created_at || it.timestamp) ? (it.created_at || it.timestamp) : null,
        product_id: it && it.product_id != null ? it.product_id : null
      }))
    },
    extractStornoAfterProducts (row) {
      const after = this.parseJsonMaybe(row && row.data_after)
      let items = []

      if (Array.isArray(after)) {
        items = after
      } else if (after && typeof after === 'object') {
        if (Array.isArray(after.items)) items = after.items
        else if (Array.isArray(after.order_part_items)) items = after.order_part_items
        else if (Array.isArray(after.products)) items = after.products
      }

      const mapped = items.map((it) => ({
        name: it && it.name ? String(it.name) : '-',
        quantity: it && it.quantity != null ? it.quantity : '-',
        price: it && it.price != null ? it.price : null,
        created_at: it && (it.created_at || it.timestamp) ? (it.created_at || it.timestamp) : null,
        options: it && Array.isArray(it.options) ? it.options : [],
        additional_info: it && it.comment ? String(it.comment) : '',
        is_storno: it && it.is_storno != null ? Number(it.is_storno) : 0
      }))

      return mapped.filter((it) => !this.isHiddenStornoDisplayLine(it))
    },
    statusPillClass (status) {
      if (!status) return ''
      return String(status)
    },
    parseJsonMaybe (val) {
      if (val === undefined || val === null) return null
      if (typeof val === 'object') return val
      const s = String(val)
      if (!s.trim()) return null
      try { return JSON.parse(s) } catch (e) { return null }
    },
    actionTypeLabel (type) {
      if (type == null || type === '') return '-'

      const numericToKey = {
        1: 'openOrder',
        2: 'markProduct',
        3: 'preNote',
        4: 'closeOrder',
        5: 'storno',
        6: 'transferOut',
        7: 'transferIn'
      }

      const key = numericToKey[Number(type)] || String(type)
      return this.$t('reports.posOrderActionTypes.' + key)
    },
    paginationChanged (query) {
      if (query.type === 'page') this.fetchActions(query)
      if (query.type === 'size') this.fetchActions(query)
      if (query.type === 'sort') this.fetchActions(query)
    },
    refreshNow () {
      // Re-fetch using current pagination state.
      const page = this.paginationProps.currentPage || 1
      const pageSize = this.paginationProps.pageSize || 20
      this.fetchActions({ page, pageSize })
    },
    goBack () {
      // Product-view-like back: close the global slide-in modal.
      // Also refresh the underlying report list (same pattern as ProductsList.vue).
      this.$bus.$emit('refreshPosOrderActions')
      this.$bus.$emit('close-modal')
    },
    hasBeforeAfter (row) {
      if (!row) return false
      const before = row.data_before
      const after = row.data_after
      const hasBefore = before !== undefined && before !== null && String(before).trim() !== ''
      const hasAfter = after !== undefined && after !== null && String(after).trim() !== ''
      return hasBefore || hasAfter
    },
    openBeforeAfterModal (row) {
      this.diffModalRow = row || null
      this.$modal.show('posOrderActionsBeforeAfterModal')
    },
    closeBeforeAfterModal () {
      this.$modal.hide('posOrderActionsBeforeAfterModal')
      this.diffModalRow = null
    },
    formatDiffValue (val) {
      if (val === undefined || val === null) return '-'
      if (typeof val === 'object') {
        try { return JSON.stringify(val, null, 2) } catch (e) { return String(val) }
      }
      const s = String(val)
      if (!s.trim()) return '-'
      try {
        const parsed = JSON.parse(s)
        return typeof parsed === 'object' && parsed !== null ? JSON.stringify(parsed, null, 2) : String(parsed)
      } catch (e) {
        return s
      }
    },
    formatToCompanyTimezone (utcString) {
      const date = new Date(utcString + 'Z')
      const formatter = new Intl.DateTimeFormat('en-GB', {
        timeZone: this.timezone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      })
      const parts = formatter.formatToParts(date)
      return `${parts.find(p => p.type === 'year').value}-${
        parts.find(p => p.type === 'month').value}-${
        parts.find(p => p.type === 'day').value} ${
        parts.find(p => p.type === 'hour').value}:${
        parts.find(p => p.type === 'minute').value}:${
        parts.find(p => p.type === 'second').value}`
    },
    fetchActions (query) {
      const pageSize = query && query.pageSize != null ? query.pageSize : (this.paginationProps.pageSize || 20)
      const page = query && query.page != null ? query.page : (this.paginationProps.currentPage || 1)

      const data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        app_id: this.appId
      }

      this.loading = true
      this.apiRequest(`/reports/v2/order-actions/order/${this.appId}?page=${page}&perPage=${pageSize}`, 'GET', data, (response) => {
        if (response && response.status === true) {
          const paginator = response.data && response.data.actions
          const rows = paginator && Array.isArray(paginator.data) ? paginator.data : []
          this.actions = rows
          this.prefetchTransferTables(rows)

          const pageFromTop = response.pagination && response.pagination.page
          const perPageFromTop = response.pagination && response.pagination.perPage
          const totalFromTop = response.pagination && response.pagination.total

          const pageFromActions = paginator && paginator.current_page
          const perPageFromActions = paginator && paginator.per_page
          const totalFromActions = paginator && paginator.total

          this.total = totalFromTop || totalFromActions || 0
          this.paginationProps.currentPage = pageFromTop || pageFromActions || page
          this.paginationProps.pageSize = perPageFromTop || perPageFromActions || pageSize
        } else {
          const code =
            (response && (response.statusCode || response.http_code || response.code)) ||
            (response && response.errors && (response.errors.statusCode || response.errors.http_code || response.errors.code)) ||
            (response && response.error && response.error.response && response.error.response.status)

          if (Number(code) === 404) {
            this.actions = []
            this.total = 0
            this.paginationProps.currentPage = 1
            this.paginationProps.pageSize = pageSize
          } else {
            swal('', this.$t('validations.wentWrong'), 'error')
          }
        }
        this.$nextTick(() => {
          this.loading = false
        })
      })
    },
    prefetchTransferTables (rows) {
      const list = Array.isArray(rows) ? rows : []
      const ids = Array.from(new Set(list.map(r => r && r.transfer_table_id).filter(v => v !== undefined && v !== null && v !== '')))
      ids.forEach((id) => {
        const key = String(id)
        if (this.transferTableNameById[key]) return
        this.fetchTransferTableById(id)
      })
    },
    fetchTransferTableById (id) {
      const data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }
      this.apiRequest('/table-management/' + id, 'GET', data, (response) => {
        if (response && response.status === true && response.data) {
          const t = response.data
          const label =
            (t.name && String(t.name).trim()) ||
            ([t.type, t.number].filter(Boolean).join(' ') || null) ||
            (t.external_id ? String(t.external_id) : null) ||
            ('ID ' + id)
          this.$set(this.transferTableNameById, String(id), label)
        } else {
          this.$set(this.transferTableNameById, String(id), 'ID ' + id)
        }
      })
    },
    transferTableName (id) {
      if (id === undefined || id === null || id === '') return '-'
      return this.transferTableNameById[String(id)] || ('ID ' + id)
    },
    openTransferOrder (row) {
      if (!row) return
      const filters = (this.route && this.route.query && this.route.query.posOrderActionsFilters) ? this.route.query.posOrderActionsFilters : undefined
      const navigateTo = (pathOrderId, appId) => {
        // Close current slide-in modal first, then reopen with the new route.
        // This avoids cases where only breadcrumbs update but content doesn't refresh.
        this.$bus.$emit('close-modal')
        setTimeout(() => {
          this.$router.push({
            path: `/reports/pos-order-actions/${pathOrderId}`,
            query: {
              tab: 'pos-order-actions',
              app_id: appId,
              ...(filters ? { posOrderActionsFilters: filters } : {})
            }
          })
        }, 50)
      }

      // Use the transfer order app id provided by backend.
      const transferAppId = row.transfer_app_id || row.transfer_order_app_id
      if (!transferAppId) {
        swal('', this.$t('validations.wentWrong'), 'error')
        return
      }
      navigateTo(transferAppId, transferAppId)
    }
  }
}
</script>

<style>
.centered-cell .cell {
  display: flex;
  justify-content: center;
  align-items: center;
}

.pos-order-actions-action-col .cell {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  white-space: normal;
  word-break: break-word;
  line-height: 1.2;
  text-align: left;
}

.pos-order-actions-action-text {
  display: inline-block;
  width: 100%;
}

.pos-order-actions-details-action-btn {
  height: 26px;
  width: 26px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 !important;
}

.pos-order-actions-diff-pre {
  background: #f7f7f7;
  border: 1px solid #eee;
  border-radius: 6px;
  padding: 10px;
  font-size: 12px;
  line-height: 1.35;
  max-height: 45vh;
  overflow: auto;
  white-space: pre-wrap;
  word-break: break-word;
}

.pos-order-actions-products {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.pos-order-actions-product-row {
  padding: 10px;
  background: #f7f7f7;
  border: 1px solid #eee;
  border-radius: 6px;
}

.pos-order-actions-product-row--storno {
  border: 1px solid #EB5E28;
}

.pos-order-actions-product-row--transfer {
  border: 1px solid #8d5e27;
}

.pos-order-actions-product-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.pos-order-actions-product-storno-tag {
  color: #EB5E28;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;
}

.pos-order-actions-product-transfer-tag {
  color: #8d5e27;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;
}

.pos-order-actions-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.pos-order-actions-product-name {
  font-weight: 600;
  color: #25396F;
}

.pos-order-actions-product-options {
  margin-top: 6px;
  font-size: 12px;
  color: #303133;
}

.pos-order-actions-product-info {
  margin-top: 6px;
  font-size: 12px;
}

.pos-order-actions-product-meta {
  margin-top: 6px;
  font-size: 12px;
  color: #666;
}

.pos-order-actions-empty {
  color: #999;
  padding: 10px 0;
}

.pos-order-actions-status-wrap {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.pos-order-actions-status-label {
  font-weight: 600;
  color: #25396F;
}

.pos-order-actions-status-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  color: #fff;
}

/* Order status colors (match PosOrderActionsReport.vue / Orders) */
.pos-order-actions-status-pill.NEW { background-color: #0097FC; }
.pos-order-actions-status-pill.PROCESSING { background-color: #F3BB45; }
.pos-order-actions-status-pill.DELIVERED { background-color: #7AC29A; }
.pos-order-actions-status-pill.CANCELED,
.pos-order-actions-status-pill.NOT_DELIVERED { background-color: #EB5E28; }
.pos-order-actions-status-pill.AWAITING_TRANSPORT { background-color: #ffc107; }
.pos-order-actions-status-pill.PICKED_UP_BY_DELIVERY { background-color: #66615B; }
.pos-order-actions-status-pill.TRANSPORT { background-color: #0f566a; }
.pos-order-actions-status-pill.ON_HOLD,
.pos-order-actions-status-pill.POSTPONED { background-color: #8d5e27; }

.pos-order-actions-status-pill.ok { background: #7AC29A; }
.pos-order-actions-status-pill.bad { background: #EB5E28; }

.pos-order-actions-status-message {
  color: #666;
  font-size: 12px;
}

/* Same modal shell as Orders.vue filtersAndSortModal — vue-js-modal puts class on .vm--container */
.vm--container.sales-report-filters .modal-footer.slim-footer {
  text-align: right;
  margin-top: 8px;
  border-top: 1px solid #eee;
  padding-top: 6px;
  padding-bottom: 0 !important;
  padding-left: 15px !important;
  padding-right: 0 !important;
}

.vm--container.sales-report-filters .slim-footer .el-button {
  font-size: 14px;
}

/* Make the diff modal body a bit tighter */
.pos-order-actions-diff-grid {
  padding-top: 4px;
}

/* Prevent sticky back-bar from overlaying vmodal */
.sales-report .settings-top-bar.sticky-header {
  z-index: 10 !important; /* below v--modal-overlay (>=1000) */
}

/* settings-top-bar has a negative top margin globally; compensate here */
.pos-order-actions-details-breadcrumbs {
  margin-bottom: 16px !important;
  padding-bottom: 15px; /* counteracts settings-top-bar margin-top:-15px without margin-collapsing issues */
}

.pos-order-actions-details-table-wrap {
  margin-top: 16px;
}
</style>




// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reports/Versions/2/PosOrderActionsDetails.vue